var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon300_contract"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_152_631",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_152_631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "contract",
    d: "M5.99997 21.5C5.30127 21.5 4.70993 21.258 4.22595 20.774C3.74198 20.29 3.5 19.6987 3.5 19V16.1154H6.5V2.50002H20.5V19C20.5 19.6987 20.258 20.29 19.774 20.774C19.29 21.258 18.6987 21.5 18 21.5H5.99997ZM18 20C18.2833 20 18.5208 19.9042 18.7125 19.7125C18.9041 19.5208 19 19.2833 19 19V4H7.99998V16.1154H17V19C17 19.2833 17.0958 19.5208 17.2875 19.7125C17.4791 19.9042 17.7166 20 18 20ZM9.1923 8.69227V7.19232H17.8077V8.69227H9.1923ZM9.1923 11.5769V10.0769H17.8077V11.5769H9.1923ZM5.99997 20H15.5V17.6153H4.99997V19C4.99997 19.2833 5.09581 19.5208 5.28747 19.7125C5.47914 19.9042 5.71664 20 5.99997 20ZM5.99997 20H4.99997H15.5H5.99997Z",
    fill: "#1C1B1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.bef742c911418d9811e516dfe76f2e44.svg";
export { ForwardRef as ReactComponent };